// App.jsx
import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AccreditationBar from './components/AccreditationBar';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Process from './components/Process';
import Tests from './components/Tests';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-dm-sans text-charcoal bg-white scroll-smooth">
      <Navbar />
      <div className="pt-[70px]">
      <Hero />
      </div>
      <AccreditationBar />
      <Services />
      <WhyChooseUs />
      <Process />
      <Tests />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;